// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__vtMQ3","boxTitle":"Qualiphy_boxTitle__28goe","box":"Qualiphy_box__1YU7V","toggleWrap":"Qualiphy_toggleWrap__LYj4p"};